import { render, staticRenderFns } from "./role.vue?vue&type=template&id=78b14977&scoped=true&"
import script from "./role.vue?vue&type=script&lang=js&"
export * from "./role.vue?vue&type=script&lang=js&"
import style0 from "./role.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./role.vue?vue&type=style&index=1&id=78b14977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b14977",
  null
  
)

export default component.exports